module.exports = __webpack_public_path__ + "assets/normal/images/wheat_ear_left.95973790.png";